import { ActionTree } from 'vuex';
import { AttachmentPreviewState } from './attachmentPreviewState';
import { isPublicPageApp } from '@/utilities/isPublicPageApp';
import { isDocx } from '@/utilities/fileExtensions';
export default {
  setPreviewAttachmentId({ commit }, { attachmentId, resourceId }) {
    commit('setPreviewAttachmentId', { attachmentId, resourceId });
  },

  async setPreviewAttachments({ commit, dispatch }, attachements) {
    if (!isPublicPageApp()) {
      const docXs: any[] = [];
      const filteredAttachments = attachements.filter((attachment: any) => {
        if (isDocx(attachment.fileType) && !attachment.url.includes('token')) {
          docXs.push(attachment);
          return false;
        }
        return true;
      });
      commit('setPreviewAttachments', filteredAttachments);
      if (docXs.length > 0) {
        for (const docX of docXs) {
          const file = await dispatch('getFile', docX.id);
          filteredAttachments.push(file);
        }
        commit('setPreviewAttachments', filteredAttachments);
      }
    } else {
      commit('setPreviewAttachments', attachements);
    }
  },

  clearCardPreviewData({ commit }) {
    commit('clearCardPreviewData');
  },

  setNextAttachment({ commit }, id) {
    commit('setNextAttachment', id);
  },

  setPreviousAttachment({ commit }, id) {
    commit('setPreviousAttachment', id);
  },

  deleteAttachmentFromPreviewAttachments({ commit }, fileId) {
    commit('deleteAttachmentFromPreviewAttachments', fileId);
  },

  setAttachmentPreviewFromInput({ commit }, value) {
    commit('setAttachmentPreviewFromInput', value);
  },
} as ActionTree<AttachmentPreviewState, any>;
